import { Button, Modal, Text } from "@marketplace/ui";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { createVoucherModalAtom } from "../../atoms";
import { useCreateVoucherForm } from "../../hooks/forms/use-create-voucher-form";
import { CreateVoucherForm } from "../create-voucher-form";

export const CreateVoucherModal = () => {
  const { t } = useTranslation("voucher");
  const { visible } = useAtomValue(createVoucherModalAtom);
  const resetCreateVoucherModal = useResetAtom(createVoucherModalAtom);
  const {
    formMethods,
    handleSubmit,
    isPending,
    resetForm,
    productListData,
    productListLoading,
    productSearchQuery,
    setProductSearchQuery
  } = useCreateVoucherForm();

  return (
    <Modal
      opened={visible}
      onClose={() => {
        resetForm();
        resetCreateVoucherModal();
      }}
      title={<Text type="heading">{t("modal.createVoucherModal.title")}</Text>}
      size={610}
      withCloseButton={false}
      classNames={{
        header: "!pb-[26px] !pt-[42px] !px-[42px] !min-h-fit",
        body: "!p-0"
      }}
    >
      <form onSubmit={handleSubmit}>
        <CreateVoucherForm
          formMethods={formMethods}
          productListData={productListData}
          productListLoading={productListLoading}
          productSearchQuery={productSearchQuery}
          setProductSearchQuery={setProductSearchQuery}
        />

        <hr className="bg-mischka-100 h-px border-0" />

        <div className="py-6 px-[42px] flex justify-end items-end gap-x-[14px] grow">
          <Button
            variant="secondary"
            className="w-[128px]"
            onClick={() => {
              resetForm();
              resetCreateVoucherModal();
            }}
          >
            {t("modal.createVoucherModal.form.button.discard")}
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="w-[128px]"
            loading={isPending}
            onClick={handleSubmit}
          >
            {t("modal.createVoucherModal.form.button.create")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
